/**
 * Avisos exibidos ao lado do título das janelas principais.
 *
 * A ideia é centralizar aqui a montagem da string de aviso, para que além do
 * aviso de valores financeiros (profiles.visualizarValores) outros avisos
 * possam ser incorporados no futuro, sem mexer em cada aba.
 */
import { obterModoValores, type ModoValores } from "@/lib/modo-valores";

export type Aviso = {
  /** Identificador do aviso. */
  id: string;
  /** Texto exibido. */
  texto: string;
  /** atencao = fundo amarelo | erro = fundo vermelho. */
  tipo?: "atencao" | "erro";
};

/** Avisos extras registrados por outras partes do app. */
type Provedor = () => Aviso | Aviso[] | null | undefined;
const provedores = new Set<Provedor>();

/** Registra um provedor de avisos adicionais. Retorna função para remover. */
export function registrarProvedorAviso(fn: Provedor) {
  provedores.add(fn);
  return () => provedores.delete(fn);
}

/** Aviso referente ao modo de visualização de valores. */
export function avisoValores(modo: ModoValores = obterModoValores()): Aviso | null {
  if (modo === 1) return { id: "valores", texto: "VALORES OCULTADOS", tipo: "erro" };
  if (modo === 2) return { id: "valores", texto: "VALORES SIMULADOS", tipo: "atencao" };
  return null;
}

/** Lista todos os avisos vigentes. */
export function listarAvisosTitulo(modo: ModoValores = obterModoValores()): Aviso[] {
  const lista: Aviso[] = [];
  const v = avisoValores(modo);
  if (v) lista.push(v);
  provedores.forEach((fn) => {
    const r = fn();
    if (!r) return;
    if (Array.isArray(r)) lista.push(...r);
    else lista.push(r);
  });
  return lista;
}

/**
 * Monta a string de aviso a ser exibida após o título da janela.
 * Retorna string vazia quando não há aviso algum.
 */
export function montarAvisoTitulo(modo: ModoValores = obterModoValores()): string {
  return listarAvisosTitulo(modo)
    .map((a) => a.texto)
    .join(" • ");
}

/** Indica se a gravação no banco deve ser bloqueada para o usuário atual. */
export function persistenciaBloqueada(modo: ModoValores = obterModoValores()): boolean {
  return modo !== 0;
}

export const MOTIVO_BLOQUEIO_PERSISTENCIA =
  "Gravação desabilitada: usuário sem acesso total aos valores financeiros.";
